var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pending"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.33301C4.31967 1.33301 1.33301 4.31967 1.33301 7.99967C1.33301 11.6797 4.31967 14.6663 7.99967 14.6663C11.6797 14.6663 14.6663 11.6797 14.6663 7.99967C14.6663 4.31967 11.6797 1.33301 7.99967 1.33301ZM7.99967 13.333C5.05301 13.333 2.66634 10.9463 2.66634 7.99967C2.66634 5.05301 5.05301 2.66634 7.99967 2.66634C10.9463 2.66634 13.333 5.05301 13.333 7.99967C13.333 10.9463 10.9463 13.333 7.99967 13.333Z",
    fill: "#8993A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 8.99967C5.21863 8.99967 5.66634 8.55196 5.66634 7.99967C5.66634 7.44739 5.21863 6.99967 4.66634 6.99967C4.11406 6.99967 3.66634 7.44739 3.66634 7.99967C3.66634 8.55196 4.11406 8.99967 4.66634 8.99967Z",
    fill: "#8993A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 8.99967C8.55196 8.99967 8.99967 8.55196 8.99967 7.99967C8.99967 7.44739 8.55196 6.99967 7.99967 6.99967C7.44739 6.99967 6.99967 7.44739 6.99967 7.99967C6.99967 8.55196 7.44739 8.99967 7.99967 8.99967Z",
    fill: "#8993A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 8.99967C11.8853 8.99967 12.333 8.55196 12.333 7.99967C12.333 7.44739 11.8853 6.99967 11.333 6.99967C10.7807 6.99967 10.333 7.44739 10.333 7.99967C10.333 8.55196 10.7807 8.99967 11.333 8.99967Z",
    fill: "#8993A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.1c538ebe477a6144cbfe94a8cc79b7b2.svg";
export { ForwardRef as ReactComponent };